module.exports = __webpack_public_path__ + "img/237.c3a15245.png";